import { api } from "@api/api";
import { ReportApiResponse } from "@modules/dashboard/types/reportApiResponse";

export async function getAgreementsService(): Promise<ReportApiResponse> {
  try {
    const { data } = await api.get<ReportApiResponse>(`v1/agreement/report`);
    return data;
  } catch (error) {
    console.error("Error fetching agreements:", error);
    throw error;
  }
}
